import ApiService from '@/services/api.service'

const PatientService = {  
 getAll(parameter) {
    // This function retrieves a list of patients based on the provided parameters
    const { 
        SearchCriteria, 
        PageSize, 
        PageNumber, 
        Status, 
        IsInpatient
    } = parameter;

    const params = {
        SearchCriteria,
        PageSize,
        PageNumber,
        ...(Status !== 'All' && { 
            Active: Status,
            IsInpatient 
        }),
    };

    return ApiService.customRequest({
        method: 'get',
        url: "/patients/",
        headers: {},
        params
    });
  },

  getPatientAll(parameter){
    return ApiService.get(`/patients/?Active=${parameter.Status}`);
  },

  
  getPatientList(){
    return ApiService.get(`/patients`);
  },

   getPatientLookup(){
    return ApiService.get(`/Patients/LookUp`);
  },



  getInfoList(PatientCode){
    var param = {};
    param.PatientCode = PatientCode;
    const requestData = {
      method: 'get',
      url: "/patients/",
      headers: {
        
      },
      params: param
    }
    return ApiService.customRequest(requestData);
  },

  get(id) {
    return ApiService.get(`/patients/${id}`);
  },

  getDiagnoses(PatientCode) {
    return ApiService.get(`/AdmissionDiagnoses?PatientCode=${PatientCode}`);
  },

  getDiagnosesByOutCome(RecordId) {
    return ApiService.get(`/AdmissionDiagnoses/ByAdmission?Code=${RecordId}`);
  },
  
  getPatientDiag(id) {
    return ApiService.get(`/Patients/PatientDiagnosis?id=${id}`);
  },
  
  getPatientAllergy(PatientCode){
    const requestData = {
      method: 'get',
      url: "/PatientAllergies/",     
      params: {
        PatientCode: `${PatientCode}`,
        IsActive:`true`
      }
    }
    return ApiService.customRequest(requestData);
  },

  getPatientDiagnosis(PatientCode){
    const requestData = {
      method: 'get',
      url: "/PatientDiagnosisSummaries/",     
      params: {
        PatientCode: `${PatientCode}`       
      }
    }
    return ApiService.customRequest(requestData);
  },

  addPatient(data) {
    return ApiService.post(`/patients`, data)
  },

  update(id, patient) {
    /* const requestData = {
       method: 'put',
       // url: "/patients/",
       url: `/patients/${id}`,
       headers: {},
       data: patient
     }*/
    return ApiService.put(`/patients/${id}`, patient);
  },

  getReferal(referalCode) {

    
    const requestData = {
      method: 'get',
      url: "/Referrals/",
      headers: {
        
      },
      params: {
        Code: `${referalCode}`,

      }
    }
    return ApiService.customRequest(requestData);



  },
  getCommunicationLiaison(commLiason) {

    const requestData = {
      method: 'get',
      url: "/CommLiason/",
      headers: {
        
      },
      params: {
        Code: `${commLiason}`,

      }
    }
    return ApiService.customRequest(requestData);

  },

  getMatrix(matrix) {

    
    const requestData = {
      method: 'get',
      url: "/Matrixes/",
      headers: {
        
      },
      params: {
        Code: `${matrix}`,

      }
    }
    return ApiService.customRequest(requestData);
  },

  
  getDoctor(doctorCode) {

    
    const requestData = {
      method: 'get',
      url: "/Doctors/",
      headers: {
        
      },
      params: {
        Code: `${doctorCode}`,

      }
    }
    return ApiService.customRequest(requestData);



  },

  getFacilities(facilitycode) {

    
    const requestData = {
      method: 'get',
      url: "/Facilities/",
      headers: {
        
      },
      params: {
        Code: `${facilitycode}`,

      }
    }
    return ApiService.customRequest(requestData);

  },

  getEmployees(employeecode) {

    
    const requestData = {
      method: 'get',
      url: "/Employees/",
      headers: {
        
      },
      params: {
        Code: `${employeecode}`,

      }
    }
    return ApiService.customRequest(requestData);

  },

  getDiagnosis(diagnosiscode) {

    
    const requestData = {
      method: 'get',
      url: "/DiagnosisICD10Providers/",
      headers: {
        
      },
      params: {
        Code: `${diagnosiscode}`,

      }
    }
    return ApiService.customRequest(requestData);

  },
  getDataHeaderRightMenu(PatientCode){    
    const requestData = {
      method: 'get',
      url: "/PatientSummaries/",     
      params: {
        PatientCode: `${PatientCode}`,

      }
    }
    return ApiService.customRequest(requestData);
  },

  getExistPatient(patientData){
    var param = {};
    param.LastName = patientData.LastName;
    param.FirstName = patientData.FirstName;
    param.DOB = patientData.DOB;
    param.PageSize = 1;
    
    const requestData = {
      method: 'get',
      url: "/patients/",
      headers: {
        
      },
      params: param
    }
    return ApiService.customRequest(requestData);
  },

  getAgeFormatted(date) {
    return ApiService.get(`/Utils/AgeFormatted?dateOfBirth=${date}`);
  },

  getDiagnosisListByPatientCode(PatientCode) {
    return ApiService.get(`/Patients/DiagnosisList?PatientCode=${PatientCode}`);
  },

  getUseAutoAssignCode(form) {
    return ApiService.get(`/Utils/UseAutoAssignCode?ClassName=${form}`);
  },

  getDefaultDoctor(PatientCode) {
    return ApiService.get(`/Patients/Doctor/${PatientCode}`);
  },

  getPatientRemarks(PatientCode) {
    return ApiService.get(`/Patients/PatientRemarks/${PatientCode}`);
  },

  getPatientFaceSheet(parameter) {
    // This function retrieves a list of patients based on the provided parameters
    const { 
        PageSize, 
        PageNumber, 
        ActivePatient,
        IncludePhoto,
        PatientCodeList
    } = parameter;

    const params = {
        IncludePhoto,
        PageNumber,
        PageSize,
        ActivePatient,
        PatientCodeList
    };
    return ApiService.getWithArray('/PatientFaceSheet',params); 
  },

  getPatientFaceSheetByAdmision(parameter) {
    // This function retrieves a list of patients based on the provided parameters
    const { 
        PageSize, 
        PageNumber, 
        ActivePatient,
        IncludePhoto,
        PatientCodeList,
        ProgamCodeList,
        ActiveAdmission,
        byadmission
    } = parameter;

    const params = {
        IncludePhoto,
        PageNumber,
        PageSize,
        ActivePatient,
        PatientCodeList,
        ProgamCodeList,
        ActiveAdmission,
        byadmission
    };
    return ApiService.getWithArray('/PatientFaceSheet/ByAdmission', params); 
  }

}
  


export default PatientService;